import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
const tomosData = [{
  icon: '📘',
  label: 'Tomo 1 — El Renacimiento del Contador · Mentalidad',
  topics: 'Filtro de Valor Digital, Configuración IA para ARCA, Protocolo de seguridad de datos, Matriz de Paz Mental.'
}, {
  icon: '📗',
  label: 'Tomo 2 — Cerebro Digital · Prompts Maestros',
  topics: 'Filtro Novedades ARCA, Descargos, Análisis de Deuda, Riesgos Fiscales, Reportes PyME, Prompts Laborales.'
}, {
  icon: '📙',
  label: 'Tomo 3 — Excel & IA · El Fin del Copiado Manual',
  topics: 'Limpieza Universal, Normalización de fechas, Macros VBA de IVA y Sueldos, Conciliación bancaria.'
}, {
  icon: '📕',
  label: 'Tomo 4 — El Multiplicador de Honorarios',
  topics: 'Menú de 3 Niveles, Anclaje de Precio, Mail de Aumento, 5 Servicios Premium, Modelo CFO Externalizado.'
}, {
  icon: '📓',
  label: 'Tomo 5 — Gestión de Clientes Sin Estrés',
  topics: 'Regla 24 Horas, WhatsApp Business Pro, Etiquetas A/B/C, Kit de Bienvenida, Guiones para situaciones difíciles.'
}, {
  icon: '📔',
  label: 'Tomo 6 — El Estudio del Futuro · Plan 90 Días',
  topics: 'Auditoría de Implementación, 5 Hábitos Diarios, LinkedIn e Instagram, Propuesta Comercial, Sistema de Referidos.'
}];
export function TomoDetails() {
  return <section className="py-20 relative" data-id="element-332">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-333">
        <FadeIn data-id="element-334">
          <div className="bg-brand-card border border-brand-accent/30 rounded-2xl p-8 md:p-10 mb-12" data-id="element-335">
            <h2 className="text-2xl md:text-3xl font-bold text-brand-accent mb-8" data-id="element-336">
              📚 6 TOMOS COMPLETOS
            </h2>

            <div className="space-y-6" data-id="element-337">
              {tomosData.map((tomo, i) => <div key={i} className="flex items-start gap-4" data-id="element-338">
                  <span className="text-2xl mt-0.5 shrink-0" data-id="element-339">{tomo.icon}</span>
                  <p className="text-lg leading-relaxed" data-id="element-340">
                    <span className="font-bold text-white" data-id="element-341">{tomo.label}</span>{' '}
                    <span className="text-slate-400" data-id="element-342">{tomo.topics}</span>
                  </p>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-343">
          <div className="bg-brand-darker border border-slate-800 p-8 rounded-2xl" data-id="element-344">
            <h3 className="text-xl font-bold text-white mb-6 text-center" data-id="element-345">
              Cada tomo incluye:
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-346">
              {['Objetivos claros por capítulo', 'Prompts listos para copiar y pegar', 'Casos prácticos del contexto argentino', 'Checklists de implementación inmediata', 'Callouts de implementación en cada sección', '100% adaptado a ARCA, normativa argentina e inflación local'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-347">
                  <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-348" />
                  <span className="text-slate-300 font-medium" data-id="element-349">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}